var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"expander-content",staticStyle:{"height":"0px"}},[_c('div',{ref:"inner",staticClass:"expander-inner",style:({opacity: (_vm.show ? 1 : 0)})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }